/* Full clinic price list — mirrors the WriteUpp booking diary.
   Categorised by appointment type. `insurance: true` = billed to insurer
   (subject to authorisation); `complimentary: true` = no charge. */
export const FEE_CATEGORIES = [
  {
    id: 'initial',
    label: 'Initial Assessments',
    blurb: 'A comprehensive consultation covering your current symptoms, followed by a detailed treatment plan tailored to your needs. Assessment-only bookings: if you would like treatment on the same day, please also schedule a follow-up appointment.',
    items: [
      { name: 'Initial Assessment — Self Pay', duration: 55, price: 295 },
      { name: 'Initial Assessment — Insurance', duration: 55, insurance: true },
      { name: 'Initial Jaw Assessment & Treatment — Self Pay', duration: 75, price: 390.40, note: 'Assessment plus same-day treatment based on clinical findings — ideal if you have been referred or already seen by another clinician.' },
      { name: 'Initial Jaw Assessment & Treatment — Insurance', duration: 75, insurance: true },
      { name: 'Initial Assessment NESA — Self Pay', duration: 30, price: 60 },
    ],
  },
  {
    id: 'followup',
    label: 'Follow-up Physiotherapy',
    blurb: 'Follow-up physiotherapy appointments with Krina at {address}.',
    items: [
      { name: 'Follow-up — Self Pay', duration: 25, price: 95.40 },
      { name: 'Follow-up — Self Pay', duration: 50, price: 190.80 },
      { name: 'Follow-up — Self Pay', duration: 75, price: 286.20 },
      { name: 'Follow-up — Insurance', duration: 25, insurance: true },
      { name: 'Follow-up — Insurance', duration: 50, insurance: true },
      { name: 'Follow-up — Insurance', duration: 75, insurance: true },
    ],
  },
  {
    id: 'nesa',
    label: 'NESA Neuromodulation',
    blurb: 'Non-invasive NESA microcurrent neuromodulation — standalone or combined with hands-on physiotherapy.',
    items: [
      { name: 'NESA Neuromodulation — Self Pay', duration: 60, price: 70 },
      { name: 'Follow-up Physiotherapy & NESA — Self Pay', duration: 50, price: 260.80 },
      { name: 'Follow-up Physiotherapy & NESA — Insurance', duration: 50, insurance: true },
    ],
  },
  {
    id: 'electroporation',
    label: 'Electroporation',
    blurb: 'Extended follow-up sessions with Krina, including electroporation.',
    items: [
      { name: 'Follow-up incl. Electroporation — Self Pay', duration: 75, price: 286.20 },
      { name: 'Follow-up incl. Electroporation — Self Pay', duration: 100, price: 381.60 },
      { name: 'Follow-up incl. Electroporation — Insurance', duration: 75, insurance: true },
      { name: 'Follow-up incl. Electroporation — Insurance', duration: 100, insurance: true },
    ],
  },
  {
    id: 'velvet',
    label: 'TMJ Velvet — Diathermy',
    blurb: 'Diathermy uses electric currents (radio and sound waves) to generate heat deep within the tissue — relaxing muscles and joints, reducing inflammation and swelling, and improving blood circulation.',
    items: [
      { name: 'TMJ Velvet — Self Pay', duration: 25, price: 70 },
      { name: 'TMJ Velvet — Self Pay', duration: 50, price: 140 },
      { name: 'TMJ Velvet — Self Pay', duration: 75, price: 210 },
      { name: 'TMJ Velvet — Insurance', duration: 25, insurance: true },
      { name: 'TMJ Velvet — Insurance', duration: 50, insurance: true },
      { name: 'TMJ Velvet — Insurance', duration: 75, insurance: true },
    ],
  },
  {
    id: 'laser',
    label: 'Laser Therapy',
    blurb: 'Low level laser therapy (photobiomodulation) for orofacial pain.',
    items: [
      { name: 'Low Level Laser Therapy', duration: 45, price: 140 },
    ],
  },
  {
    id: 'massage',
    label: 'Massage Therapy',
    blurb: 'Therapeutic massage in our Waterloo space — jaw-focused or whole-body.',
    items: [
      { name: 'Jaw Massage', duration: 45, price: 75 },
      { name: 'Jaw Massage with Back Massage', duration: 75, price: 110 },
      { name: 'Jaw Massage with Full Body Massage', duration: 105, price: 135 },
      { name: 'Full Body Massage', duration: 60, price: 60 },
      { name: 'Full Body Massage', duration: 90, price: 90 },
      { name: 'Full Body Massage', duration: 120, price: 120 },
    ],
  },
  {
    id: 'botox',
    label: 'Jaw Tension Assessment & Treatment — with Dr Kartik Patel',
    blurb: 'Masseter reduction consultation for jaw tension and clenching, assessed and treated by Dr Kartik Patel.',
    items: [
      { name: 'Jaw Tension Assessment & Treatment', duration: 55, price: 550 },
      { name: 'Follow-up — Jaw Tension Treatment', duration: 25, complimentary: true },
      { name: 'Virtual Consultation — Jaw Tension', duration: 15, complimentary: true },
    ],
  },
  {
    id: 'virtual',
    label: 'Virtual Appointments',
    blurb: 'Online consultations from wherever you are.',
    items: [
      { name: 'Virtual Initial Assessment with Krina Panchal', duration: 50, price: 100 },
      { name: 'Virtual Appointment with Dr Kartik Patel', duration: 15, price: 40 },
    ],
  },
];

export const formatFeePrice = (p) => (Number.isInteger(p) ? `${p}` : p.toFixed(2));
